import {
    back,
    forward,
    freeze,
    go,
    init,
    push,
    replace,
} from './actions'
import {ActionReducerMapBuilder} from '@reduxjs/toolkit'
import {NavigationState} from './types'
import {closeSession} from 'api/action/closeSession'
import {initialState} from 'navigation/slice'

export const reducers = (builder: ActionReducerMapBuilder<NavigationState>): void => {
    builder
        .addCase(back, (state) => {
            state.position -= 1
        })
        .addCase(forward, (state) => {
            state.position += 1
        })
        .addCase(go, (state, action) => {
            state.position += action.payload
        })
        .addCase(init, (state, action) => {
            const {route} = action.payload

            state.routes = route ? [route] : state.routes.length ? state.routes : [null]
            state.position = state.routes.length - 1
        })
        .addCase(push.fulfilled, (state, action) => {
            const {route} = action.payload

            state.routes.splice(state.position + 1)
            state.routes.push(route)
            state.position = state.routes.length - 1
        })
        .addCase(freeze, () => {
            // nothing to change. may want to add a check and add more guard in the future
        })
        .addCase(replace.fulfilled, (state, action) => {
            const {route} = action.payload

            state.routes.splice(state.position + 1)
            state.routes.splice(-1, 1, route)
        })
        .addCase(replace.rejected, (state, action) => {
            if (typeof action.payload === 'number') {
                if (state.position > action.payload) {
                    state.position -= 1
                    state.routes.splice(action.payload, 1)
                } else {
                    state.routes.splice(state.position + 1)
                    state.routes.splice(-1, 1, null)
                }
            }
        })
        .addCase(closeSession.pending, () => initialState)
}
